import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import ReactTable from 'react-table';
import ReactTooltip from 'react-tooltip'
import moment from 'moment';
import SchoolMealProgramView from '../../SchoolAdmin/SchoolMealProgram/schoolMealProgramView'
import { schoolLunchAppPrint } from '../../SchoolAdmin/SchoolMealProgram/schoolLunchAppForPrint'
import { date_format } from '../../../server/constants';
import queryString from 'query-string';
import print from 'print-js';
import { get } from "../../../server/actionsNew";
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError } from '../../../server/util'
import '../../../../src/assets/css/react-table.css';
import { getLoginDistrictInfo } from "../../../server/utilDistrict";
class applicationDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            applications: [],
            columns: [],
            data: [],
            filter: '',
            schoolID: 0,
            schoolYear: 0,
            search: '',
            isPending: true,
            pendingApplications: [],
            verifiedApplications: [],
            userInfo: getLoginDistrictInfo(),
            search: {
                searchText: '',
                searchStatus: 'All',
                isCategoryCheck: false,
            },
            statusList: [],
            catagoryList: [],
            newFilterData: [],
            categoryFilterData: [],
            districtSettings: {},
            schoolYearSettings: {}
        }

        this.getColumns = this.getColumns.bind(this);
    };
    componentWillMount = () => {
        this.setState({ columns: this.getColumns() });
        this.props.changeShowHideSchoolFitler(true);
    }
    componentDidUpdate = (prevProps, prevState) => {
        console.log("componentDidUpdate------->", this.props.selectSchool);
        if (prevProps.selectSchool !== this.props.selectSchool)
            this.getAllApplications(this.props.selectSchool)
    }
    componentDidMount = async () => {
        const parsed = queryString.parse(window.location.search);
        this._notificationSystem = this.refs.notificationSystem;
        this.getAllApplications(this.props.selectSchool);
        this.getDistrictSettings();
        this.getSchoolYearSettings(this.state.userInfo.schools[0].districtId);
    }
    getDistrictSettings = () => {
        get(`/district-config/${this.state.userInfo.districtId}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({
                districtSettings: {
                    "districtId": data.districtId,
                    "confirmingOfficialEnabled": data.confirmingOfficialEnabled,
                    "confirmingOfficialUserIds": data.confirmingOfficialUserIds
                },
                loading: false
            })
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log('Get Users data response', error)
            }
        );

    }
    getSchoolYearSettings = (districtId) => {
        get('/schooldata/activeSchoolYears/' + districtId + '?access_token=')
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({ schoolYearSettings: data || {} });
            }).catch(
                (error) => {
                    console.log('Get manage school response', error)
                }
            );
    }
    _addNotification(event) {
        this._notificationSystem.addNotification({
            title: "Failed",
            message: 'Something went wrong, Please try again later',
            level: 'error',
            position: 'tc',
            autoDismiss: '5',
            uid: 5,
        });
    }
    getAllApplications = (schoolID = 0) => {
        const schoolData = this.state.userInfo.schools.find((item) => {
            if (item.schoolId === parseInt(this.props.selectSchool)) {

                return item
            }
        })
        //pass schoolYear=0 if all schools option selceted in drop down
        let schoolYear = 0
        if (schoolData) {
            schoolYear = schoolData.activeSchoolYear || 0
        }
        if (parseInt(schoolID) === 0) schoolYear = 0
        const districtID = sessionStorage.getItem('districtId');

        get('/getHouseholdApp/?mealSchoolId=' + schoolID + '&schoolYear=' + schoolYear + '&districtId=' + districtID + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log(data)
            let approved = 0;
            let pending = 0;
            let Incomplete = 0;
            let denied = 0;
            let cancelled = 0;
            const resData = data.map(item => {
                if (item.status === 'approved') {
                    approved++;
                } else if (item.status === 'pending') {
                    pending++;
                } else if (item.status === 'in-complete') {
                    Incomplete++;
                } else if (item.status === 'denied') {
                    denied++;
                } else if (item.status === 'cancelled') {
                    cancelled++;
                }
                if (item.status === 'approved' || item.status === 'declined') {
                    const kidsList = []
                    item.householdAppInfo.filter(s => s.personType === "Student").map((kid) => {
                        const rec = {};
                        rec[kid.lname + ', ' + kid.fname] = (kid.isFreeMeal ? 'Free' : (kid.isFreeMeal === false ? 'Reduced' : 'Regular'));
                        kidsList.push(rec);
                    })
                    item.eligibility = kidsList;
                } else {
                    item.eligibility = [];
                }
                return item;
            });
            // const statusList = [{"totalApproved":approved, "totalPending":pending,"totalIncomplete":Incomplete, "totalDenied":denied, "totalCancelled":cancelled}];   
            const statusList = [
                { status: "Approved", total: approved },
                { status: "Pending", total: pending },
                { status: "In-complete", total: Incomplete },
                { status: "Denied", total: denied },
                { status: "Cancelled", total: cancelled },
                { status: "Total", total: approved + pending + Incomplete + denied + cancelled },
            ];
            const statusListWithAnchors = statusList.map(item => ({
                ...item,
                total: <a href="#" onClick={() => this.handleStatusAnchorClick(item.status, item.total)}>{item.total}</a>,
            }));
            console.log("resData::::::::", resData);
            this.getByCategoryOnClickOfStatusAnchorTags(data);
            this.setState({ data: resData, statusList: statusListWithAnchors, newFilterData: resData, categoryFilterData: resData });
        }).catch(
            (error) => {
                this._addNotification();
                console.log(' response', error)
            }
        )
    }
    filterData = () => {
        const { search, data } = this.state;
        const appStatus = {
            'declined': 'Verified',
            'in-complete': 'In-complete',
            'approved': 'Verified',
            'pending': 'Pending',
            'cancelled': 'Cancelled',
            'denied': 'Denied'
        };
        if (search.searchText === '' && (search.searchStatus === 'All' || search.searchStatus === '')) {
            this.setState({ newFilterData: data, categoryFilterData: data }, () => {
                this.getByCategoryOnClickOfStatusAnchorTags(this.state.newFilterData);
            });
            return;
        }

        const filteredData = (data || []).filter(app => {
            const appid = ("00000" + app.applicationId).slice(-5);
            return (
                (search.searchText === '' || appid.includes(search.searchText) || (app.prmyParentEmail || '').includes(search.searchText)) &&
                (search.searchStatus === 'All' || appStatus[app.status] === search.searchStatus)
            );
        });
        this.setState({ newFilterData: filteredData, categoryFilterData: filteredData }, () => {
            this.getByCategoryOnClickOfStatusAnchorTags(this.state.newFilterData);
        });
    };

    handleStatusAnchorClick = (status, total) => {
        console.log(`Status: ${status}, Total: ${total}`);
        let searchStatus = status === 'Total' ? 'All' : (status === 'Approved' ? 'Verified' : status);
        this.setState(prevState => ({
            search: { ...prevState.search, searchStatus }
        }), () => {
            this.filterData();
        });
    };

    handleCategoryAnchorClick = (category, item) => {
        const { categoryFilterData } = this.state;
        const categories = {
            'Income': ["FederalIncome", "StateIncome", ""],
            'Case Based': ["TANF", "SNAP", "FDPIR"],
            'Other Categorical': ["Foster", "Homeless", "Migrant", "Runaway", "HeadStart"]
        };
        const eligibility = categories[category] || [];

        const filteredData = (categoryFilterData || []).filter(app => {
            if (!eligibility.includes(app.eligibilityDeterminedByProgam)) {
                return false;
            }
            const firstStudent = app.householdAppInfo.find(kid => kid.personType === "Student");
            if (!firstStudent) {
                return false;
            }
            switch (item) {
                case "free":
                    return firstStudent.isFreeMeal === true;
                case "reduced":
                    return firstStudent.isFreeMeal === false;
                case "errorProne":
                    return app.errorProne;
                case "regular":
                    return firstStudent.isFreeMeal === null;
                default:
                    return true;
            }
        });

        this.setState({
            newFilterData: filteredData
        });
    };


    getByCategoryOnClickOfStatusAnchorTags = (data) => {
        let free = 0;
        let reduced = 0;
        let regular = 0;
        let catList = [];

        data.forEach(item => {

            let catObj = {};
            if (["FederalIncome", "StateIncome", ""].includes(item.eligibilityDeterminedByProgam)) {
                catObj.category = "Income";
            } else if (["TANF", "SNAP", "FDPIR"].includes(item.eligibilityDeterminedByProgam)) {
                catObj.category = "Case Based";
            } else if (["Foster", "Homeless", "Migrant", "Runaway", "HeadStart"].includes(item.eligibilityDeterminedByProgam)) {
                catObj.category = "Other Categorical";
            }

            const firstStudent = item.householdAppInfo.find(s => s.personType === "Student");
            if (firstStudent) {
                if (firstStudent.isFreeMeal === true) {
                    free++;
                } else if (firstStudent.isFreeMeal === false) {
                    reduced++;
                } else {
                    regular++;
                }
            }

            catObj.free = free;
            catObj.reduced = reduced;
            catObj.errorProne = item.errorProne ? 1 : 0;
            catObj.regular = regular;
            catList.push(catObj);

            // Reset counters for the next item
            free = 0;
            reduced = 0;
            regular = 0;

        });

        const categoryList = catList.reduce((result, item) => {
            const existingItem = result.find(r => r.category === item.category);
            if (existingItem) {
                existingItem.free += item.free;
                existingItem.reduced += item.reduced;
                existingItem.errorProne += item.errorProne;
                existingItem.regular += item.regular;
            } else {
                result.push({
                    category: item.category,
                    free: item.free,
                    reduced: item.reduced,
                    errorProne: item.errorProne,
                    regular: item.regular
                });
            }
            return result;
        }, []);

        const categoryListWithAnchors = categoryList.map(item => ({
            ...item,
            free: <a href="#" onClick={() => this.handleCategoryAnchorClick(item.category, "free")}>{item.free}</a>,
            reduced: <a href="#" onClick={() => this.handleCategoryAnchorClick(item.category, "reduced")}>{item.reduced}</a>,
            errorProne: <a href="#" onClick={() => this.handleCategoryAnchorClick(item.category, "errorProne")}>{item.errorProne}</a>,
            regular: <a href="#" onClick={() => this.handleCategoryAnchorClick(item.category, "regular")}>{item.regular}</a>
        }));

        this.setState({
            catagoryList: categoryListWithAnchors
        });
    }

    getColumns = () => {
        let columns = [];
        columns.push({
            accessor: 'applicationId',
            id: "applicationId",
            Header: 'App. ID',
            sortable: true,
            Cell: (props) => (("00000" + props.value).slice(-5)),
            style: { textAlign: 'center' },
            width: 100
        });
        columns.push({
            accessor: 'date',
            Header: 'APPLIED ON',
            Cell: (props) => (moment(props.value, 'MMDDYYYY').format('YYYY/MM/DD')),
            style: { textAlign: 'center' },
            width: 100
        });
        columns.push({
            accessor: 'mealSchoolId',
            Header: 'School',
            Cell: (props) => {
                const _school = (this.props.schoolList || []).find(school => {
                    return school.schoolId == props.value
                })
                return (_school || {}).schoolName || ''

            },
            style: { textAlign: 'center' },
            width: 200
        });
        columns.push({
            accessor: 'prmyParentEmail',
            Header: 'Parent Email Id',
            style: { textAlign: 'center' }
        });
        columns.push({
            accessor: 'eligibility',
            Header: 'ELIGIBILITY',
            style: { textAlign: 'center' },
            Cell: ({ row }) => {
                let obj = (row._original.eligibility || []).length > 0 ? (row._original.eligibility || [])[0] : {};
                let status = obj[Object.keys(obj)[0]] || '';

                return (
                    status
                )
            }
        });
        columns.push({
            id: 'status',
            accessor: "status",
            Header: 'APP. STATUS',
            style: { textAlign: 'center' }, // className: "actions text-center"
            width: 100,
            Cell: ({ row }) => (
                <div style={{ textAlign: "center" }}>
                    {
                        row._original.status === 'declined' ?
                            <span><i className="fa fa-circle color-3"></i> Verified</span> :
                            row._original.status === 'in-complete' ?
                                <Fragment>
                                    <i className="fa fa-circle color-1"></i> <a className="btn-linkedin-link" style={{ padding: '0px', cursor: 'pointer' }}
                                        data-tip data-for={'rtd-' + row._original.applicationId}>
                                        {'In-complete'}</a>
                                    <ReactTooltip multiline={true} id={'rtd-' + row._original.applicationId} aria-haspopup='true' type="dark" effect="float">
                                        <div>
                                            <ul style={{ textAlign: 'left' }}>
                                                {(row._original.incompleteReasonList || []).map((item, i) => {
                                                    if (item.isApplicable) {
                                                        return <li>{item.name === 'Other:' ? item.description : item.name
                                                        }</li>
                                                    }

                                                })}
                                            </ul>

                                        </div>
                                    </ReactTooltip>
                                </Fragment> :
                                row._original.status === 'approved' ?
                                    <span><i className="fa fa-circle color-2"></i> Verified</span> :
                                    row._original.status === 'cancelled' ?
                                        <Fragment>
                                            <i className="fa fa-circle color-3"></i> <a className="btn-linkedin-link" style={{ padding: '0px', cursor: 'pointer' }}
                                                data-tip data-for={'rtd-' + row._original.applicationId}>
                                                {'Cancelled'}</a>
                                            <ReactTooltip multiline={true} id={'rtd-' + row._original.applicationId} aria-haspopup='true' type="dark" effect="float">
                                                <div>
                                                    {row._original.cancelledNote}

                                                </div>
                                            </ReactTooltip>
                                        </Fragment> :
                                        row._original.status === 'denied' ?
                                            <span><i className="fa fa-circle color-3"></i> Denied</span> :
                                            <span><i className="fa fa-circle color-4"></i> Pending</span>
                    }
                </div>
            ),
        });
        return columns;
    }

    schoolLunchLetterPrint = (appData) => {
        this.setState({ loading: true });
        get(`/generateHoseholdLetter/${appData.applicationId}?access_token=`)
            .then(async (response) => {
                // ❌ Handle error responses
                if (!response.ok) {
                    const errorRes = await response.json();
                    throw errorRes; // pass full error object
                }

                // ✅ Success → return PDF blob
                return response.blob();
            })
            .then((blob) => {
                print(URL.createObjectURL(blob));
                this.setState({ loading: false });
            })
            .catch((error) => {
                let msg = 'Failed to generate household letter';

                if (error && error.errorMessage) {
                    msg = error.errorMessage;
                } else if (error && error.statusMessage) {
                    msg = error.statusMessage;
                }

                _addNotificationError(msg, this);
                this.setState({ loading: false });
            });
    };

    getCatogoryColumns = () => {
        const columns = [
            {
                Header: "Category",
                accessor: "category",
                style: { textAlign: 'center' },
                filterable: false,
            },
            {
                Header: "Free",
                accessor: "free",
                style: { textAlign: 'center' },
                filterable: false,
            },
            {
                Header: "Reduced",
                accessor: "reduced",
                style: { textAlign: 'center' },
                filterable: false,
            },
            {
                Header: "Error Prone",
                accessor: "errorProne",
                style: { textAlign: 'center' },
                filterable: false,
            },
            {
                Header: "Regular",
                accessor: "regular",
                style: { textAlign: 'center' },
                filterable: false,
            },
        ]
        return columns;
    }

    getStatusColumns = () => {
        const columns = [
            {
                Header: "Status",
                filterable: false,
                accessor: "status",
                style: { textAlign: 'center' },
                // Cell: row => (<span>Total</span>),
            },
            {
                Header: "Total",
                filterable: false,
                accessor: "total",
                style: { textAlign: 'center' },
                filterable: false,
            }
        ]
        return columns;
    }



    render() {
        const { districtSettings, schoolYearSettings, userInfo } = this.state;
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                                <span>Application Details</span>
                            </h2>
                        </div>

                        <div className="container" style={{ marginBottom: '20px' }}>
                            <div className="row" style={{ display: 'flex' }}>
                                <div className="col-md-6 col-12">
                                    <div className="row sectionTitle priceTitle" style={{ margin: "-5%" }}>
                                        <span><h2>By Status</h2></span>
                                    </div>
                                    <div style={{ marginLeft: '-2%' }}>
                                        <ReactTable
                                            showPaginationBottom={false}
                                            columns={this.getStatusColumns()}
                                            data={this.state.statusList}
                                            defaultPageSize={6}
                                            className="-striped -highlight"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6 col-12">
                                    <div className="row sectionTitle priceTitle" style={{ margin: "-5%" }}>
                                        <span><h2>By Category</h2></span>
                                    </div>
                                    <div style={{ marginLeft: '-2%' }}>
                                        <ReactTable
                                            showPaginationBottom={false}
                                            columns={this.getCatogoryColumns()}
                                            data={this.state.catagoryList}
                                            defaultPageSize={3}
                                            className="-striped -highlight"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-5">
                                <input type="text" id="search"
                                    className="search form-control"
                                    style={{
                                        float: 'left',
                                        margin: '5px 0'
                                    }}
                                    name="search"
                                    placeholder="Enter parent email..."
                                    value={this.state.search.searchText}
                                    onChange={(e) => {
                                        const searchText = e.target ? e.target.value : '';
                                        this.setState(prevState => ({
                                            search: { ...prevState.search, searchText }
                                        }), () => {
                                            this.filterData();
                                        });
                                    }}
                                />
                            </div>

                            <div className="col-md-2" style={{
                                float: 'right',
                                textAlign: 'right',
                                margin: '5px 0'
                            }}>
                                <span style={{
                                    paddingTop: 12,
                                    fontWeight: 600,
                                    fontSize: 11
                                }}>
                                    <span >{`Total ${this.state.search.searchStatus == 'All' ? '' : this.state.search.searchStatus} Records : ${this.state.newFilterData.length}`}</span>
                                </span>
                            </div>

                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <section className="clearfix">
                                        <div className="tab-content">
                                            <div className="media">
                                                <div className="panel panel-primary">
                                                    <div className="panel-body">
                                                        <ReactTable data={this.state.newFilterData.sort((r1, r2) => {
                                                            return r2.applicationId - r1.applicationId
                                                        })}
                                                            columns={this.state.columns}
                                                            defaultPageSize={10}
                                                            className="-striped -highlight"

                                                            SubComponent={(row) => {
                                                                const schoolConfirmUsers = [];
                                                                ((schoolYearSettings[row.original.mealSchoolId] || {}).confirmingOfficialUserIds || '').split(",").map(id => {
                                                                    if (id.length > 0) {
                                                                        schoolConfirmUsers.push(parseInt(id))
                                                                    }
                                                                });
                                                                return (
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <button className="btn btn-xs btn-primary pull-right" onClick={() => {
                                                                                schoolLunchAppPrint(row.original);
                                                                            }}>
                                                                                <i className="fa fa-print"></i><span>print</span></button>
                                                                            {
                                                                                (row.original.status === 'declined' || row.original.status==='denied' || row.original.status === 'in-complete' || row.original.status === 'approved') ?
                                                                                    <button className="btn btn-xs btn-primary pull-right" onClick={() => {
                                                                                        this.schoolLunchLetterPrint(row.original);
                                                                                    }}><i className="fa fa-print"></i><span>print Letter</span></button> : null
                                                                            }
                                                                            <div className="row">
                                                                                <div className="col-md-12" id={'app' + row.index}>
                                                                                    <SchoolMealProgramView
                                                                                        id={row.index}
                                                                                        appData={row.original}
                                                                                        confirmingOfficialUserIds={[
                                                                                            ...(districtSettings.confirmingOfficialUserIds || []),
                                                                                            ...schoolConfirmUsers
                                                                                        ]}
                                                                                        enableConfirmingOfficial={districtSettings.confirmingOfficialEnabled}
                                                                                        autoDecisionEligibility={(schoolYearSettings[row.original.mealSchoolId] || {}).autoDecisionEligibility}
                                                                                        loggedUser={userInfo}
                                                                                        refNotify={this}
                                                                                        onSubmitChanges={() => {
                                                                                            this.getAllApplications(this.props.selectSchool);
                                                                                        }} isAdmin={true} />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        );
    }
}

export default applicationDetails;




// WEBPACK FOOTER //
// ./src/components/District/Applications/applicationDetails.jsx